import { createSearchParams } from 'react-router';
import isURL from 'validator/lib/isURL';

export class RouterUtils {
  static encodeSearchParams = (params: Record<string, unknown>) => {
    const newFilter: Record<string, string> = {};
    Object.keys(params).forEach(key => {
      // Remove undefined keys
      if (!params[key]) {
        return;
      }

      try {
        // we don't stringify strings with quotes unless for numeric-like
        // for example:
        // "abc" => param=abc
        // "123" => param="123"
        // 123 => param=123
        if (typeof params[key] === 'string' && !/^\d+$/.test(String(params[key]))) {
          newFilter[key] = String(params[key]);
        } else {
          newFilter[key] = JSON.stringify(params[key]);
        }
      } catch {}
    });
    return createSearchParams(newFilter);
  };

  static decodeSearchParams = (searchParams: URLSearchParams) =>
    [...searchParams.entries()].reduce((acc, [key, val]) => {
      try {
        return {
          ...acc,
          [key]: JSON.parse(val),
        };
      } catch {
        return {
          ...acc,
          [key]: val,
        };
      }
    }, {});

  static externalRedirect = (url: string | null | undefined, inNewTab = false) => {
    if (typeof url !== 'string') {
      const error = new Error('URL is undefined in external redirect');
      throw error;
    }
    const isValidUrl = isURL(url, {
      protocols: ['https'],
      require_protocol: true,
    });
    if (!isValidUrl) {
      const error = new Error(`URL is invalid for external redirection: ${url}`);
      throw error;
    }
    if (inNewTab) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };
}
